(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-delivery-block"] && !Shopify.designMode) return;
  try {
    (function () {
  var root = document.querySelector('.product-delivery');
  if (!root) return;

  var storesEl = root.querySelector('[data-delivery-stores]');
  var stores = [];
  try {
    // Même normalisation que le portail reprise : la donnée du metafield peut arriver
    // double-encodée (chaîne JSON contenant du JSON) selon la republication de l'app.
    var parsed = JSON.parse(storesEl.textContent);
    if (typeof parsed === 'string') parsed = JSON.parse(parsed);
    stores = Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    stores = [];
  }

  var resultsWrap = root.querySelector('[data-delivery-results]');
  var resultsLabel = root.querySelector('[data-delivery-results-label]');
  var resultsList = root.querySelector('[data-delivery-results-list]');
  var postalInput = root.querySelector('[data-delivery-postal]');

  var L = {
    dept: root.getAttribute('data-l-dept') || '',
    near: root.getAttribute('data-l-near') || '',
    metaIn: root.getAttribute('data-l-meta-in') || '',
    metaNeighbor: root.getAttribute('data-l-meta-neighbor') || '',
    metaFar: root.getAttribute('data-l-meta-far') || ''
  };

  var recordChoice = root.getAttribute('data-record-choice') === 'true';
  var selectedStore = null;
  var customer = { zip: '' };

  // Département = 2 premiers chiffres du CP. padStart : un zip sérialisé en NOMBRE perd son
  // zéro initial (06000 -> 6000), ce qui donnerait le département 60 au lieu du 06.
  function dep(zip) {
    var digits = String(zip == null ? '' : zip).replace(/\D/g, '');
    if (digits.length < 4) return NaN;
    return parseInt(digits.padStart(5, '0').slice(0, 2), 10);
  }

  // Enregistre le choix de livraison dans les attributs de commande (visibles côté ops MINT).
  // Le pré-remplissage de l'ADRESSE de checkout n'est pas fait ici : Shopify ne le supporte
  // que via un cart permalink (qui remplacerait le panier) ou la Storefront Cart API (preferences).
  function pushCartAttributes() {
    if (!recordChoice) return;
    var mode = root.querySelector('[data-delivery-mode]:checked');
    var attrs = {
      'Mode de livraison': mode ? mode.getAttribute('data-mode-label') : ''
    };
    if (mode && mode.value === 'home') {
      var speed = root.querySelector('[data-delivery-speed]:checked');
      attrs['Option de livraison'] = speed ? speed.getAttribute('data-speed-label') : '';
      attrs['Boutique de retrait'] = '';
    } else if (mode && mode.value === 'shop') {
      attrs['Option de livraison'] = '';
      attrs['Boutique de retrait'] = selectedStore ? selectedStore.title : '';
    } else {
      attrs['Option de livraison'] = '';
      attrs['Boutique de retrait'] = '';
    }
    attrs['Code postal client'] = customer.zip || '';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function renderStores() {
    // La liste est reconstruite : toute sélection précédente devient caduque (sinon on
    // enverrait une boutique qui ne correspond plus au code postal saisi).
    selectedStore = null;
    var zip = customer.zip;
    if (!/^\d{5}$/.test(zip) || !stores.length) {
      resultsWrap.hidden = true;
      resultsList.innerHTML = '';
      return;
    }
    var d = dep(zip);
    var ranked = stores
      .map(function (b) {
        return { b: b, d: dep(b.zip) };
      })
      // Écarte les boutiques sans CP exploitable ni libellé : sinon d = NaN, le comparateur
      // renvoie NaN et l'ordre de tri devient indéfini (des boutiques valides sautent du top 3).
      .filter(function (x) {
        return isFinite(x.d) && (x.b.name || x.b.city);
      })
      .map(function (x) {
        return { b: x.b, d: Math.abs(x.d - d) };
      })
      .sort(function (a, z) {
        return a.d - z.d;
      })
      .slice(0, 3);

    if (!ranked.length) {
      resultsWrap.hidden = true;
      return;
    }

    resultsLabel.textContent =
      ranked[0].d === 0 ? L.dept.replace('[dept]', zip.slice(0, 2)) : L.near;

    resultsList.innerHTML = '';
    ranked.forEach(function (item) {
      var b = item.b;
      var title = (b.city ? b.city + ' — ' : '') + (b.name || '');
      var meta = item.d === 0 ? L.metaIn : item.d <= 1 ? L.metaNeighbor : L.metaFar;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-delivery__store';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('data-cta-name', 'Boutique · ' + title);
      btn.setAttribute('data-delivery-cta', '');
      btn.innerHTML =
        '<span class="product-delivery__store-radio" aria-hidden="true"><span class="product-delivery__store-dot"></span></span>' +
        '<span class="product-delivery__store-body">' +
        '<span class="product-delivery__store-title"></span>' +
        '<span class="product-delivery__store-meta"></span></span>';
      btn.querySelector('.product-delivery__store-title').textContent = title;
      btn.querySelector('.product-delivery__store-meta').textContent = meta;
      btn.addEventListener('click', function () {
        selectedStore = { title: title, zip: b.zip, city: b.city };
        resultsList.querySelectorAll('.product-delivery__store').forEach(function (el) {
          el.setAttribute('aria-checked', 'false');
        });
        btn.setAttribute('aria-checked', 'true');
        pushCartAttributes();
      });
      resultsList.appendChild(btn);
    });
    resultsWrap.hidden = false;
  }

  // Annonce le mode retenu à la carte « date de livraison estimée » du bloc sticky
  // (product-essentials-delivery.liquid).
  // Seule la clé de mode circule ; chaque surface lit ses délais dans MintDelivery.
  // Clés : standard | express | shop | mint.
  function emitDeliveryChange() {
    var mode = root.querySelector('[data-delivery-mode]:checked');
    if (!mode) return;
    var key = mode.value;
    if (key === 'home') {
      var speed = root.querySelector('[data-delivery-speed]:checked');
      key = speed ? speed.value : 'standard';
    }
    document.dispatchEvent(new CustomEvent('delivery:change', { detail: { mode: key } }));
  }

  root.querySelectorAll('[data-delivery-mode]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.value !== 'shop') selectedStore = null;
      pushCartAttributes();
      emitDeliveryChange();
    });
  });
  root.querySelectorAll('[data-delivery-speed]').forEach(function (input) {
    input.addEventListener('change', function () {
      pushCartAttributes();
      emitDeliveryChange();
    });
  });

  if (postalInput) {
    postalInput.addEventListener('input', function () {
      customer.zip = postalInput.value.replace(/\D/g, '').slice(0, 5);
      renderStores();
    });
    postalInput.addEventListener('change', function () {
      if (/^\d{5}$/.test(customer.zip)) pushCartAttributes();
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trustpilot-carousel-fallback"] && !Shopify.designMode) return;
  try {
    // Ce repli n'est cliquable que si le carrousel n'a pas chargé : l'event mesure aussi,
  // indirectement, la part de visiteurs qui ne voient jamais le TrustBox. Même nom
  // d'event que trustpilot-fallback.liquid (même geste, même destination), distingué par
  // son link_location. Écouteur propre et sélecteur propre : poser `data-tp-fallback` ici
  // ferait remonter l'autre écouteur avec un link_location faux.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var link = target.closest('[data-tp-carousel-fallback]');
    if (!link) return;

    var payload = { link_url: link.href, link_location: 'product_reviews_carousel' };

    if (typeof window.trackEvent === 'function') {
      window.trackEvent('trustpilot_fallback_click', payload);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'trustpilot_fallback_click',
      link_url: payload.link_url,
      link_location: payload.link_location
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trustpilot-fallback"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var link = target.closest('[data-tp-fallback]');
    if (!link) return;

    // Le repli n'est cliquable que si le widget n'a pas chargé : cet event mesure
    // aussi, indirectement, la part de visiteurs qui ne voient jamais le TrustBox.
    var payload = {
      link_url: link.href,
      link_location: link.closest('.product-conseil-mint__trustpilot')
        ? 'product_conseil'
        : 'product_breadcrumb'
    };

    if (typeof window.trackEvent === 'function') {
      window.trackEvent('trustpilot_fallback_click', payload);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'trustpilot_fallback_click',
      link_url: payload.link_url,
      link_location: payload.link_location
    });
  });
  } catch(e) { console.error(e); }
})();

})();
